import React, { useEffect, useState } from "react";
import { Table, Button, Tag, Card, message } from "antd";
import { getFirestore } from "firebase/firestore";
import { formatTimestamp, statusList, copyDataToClipboard } from "../../../utils";
import { Gallery } from "../../Orders/Gallery";
import { zones } from "../../../locations";

const validStatuses = ["En ruta"];

export const TableOnRoute = ({ data }) => {
  const [dataNew, setDataNew] = useState([]);
  const [receipts, setReceipts] = useState();
  const [openReceipt, setOpenReceipt] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  const querydb = getFirestore();

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRowsData) => {
      setSelectedRows(selectedRowsData);
    },
  };

  const selectReceipts = async (order) => {
    setReceipts(order.fileImage);
    setOpenReceipt(true);
  };

  function getZoneForDistrict(district) {
    for (const [zone, districts] of Object.entries(zones)) {
      if (districts.map(d => d.toLowerCase()).includes(district.toLowerCase())) {
        return zone;
      }
    }
    return "Sin zona";
  }



  function handleCopyButtonClick() {
    if (!selectedRows || selectedRows.length === 0) {
      message.error('Nada seleccionado para copiar');
      return;
    }

    const groupedDataByZone = {};

    selectedRows.forEach(order => {
      const zone = getZoneForDistrict(order.district);
      if (!groupedDataByZone[zone]) {
        groupedDataByZone[zone] = [];
      }
      groupedDataByZone[zone].push(order);
    });

    const copiedData = [];

    for (const [zone, orders] of Object.entries(groupedDataByZone)) {
      copiedData.push(zone.toUpperCase());

      orders.forEach(order => {
        copiedData.push(`# ${order.serial} / ${order.channel} / ${order.managementtype} / ${order.customerName} / ${order.phoneNumber} / ${order.district} / ${order.address}  / S/${order.payable.toFixed(2)}`);
      });

      copiedData.push('');
    }

    copyDataToClipboard(copiedData.join('\n'));
    message.success('Datos copiados al portapapeles');
  }

  useEffect(() => {
    const filteredData = data.filter(order => validStatuses.includes(order.status) && (order.department === "LIMA" || order.department === "CALLAO"));
    setDataNew(filteredData);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [querydb, data]);


  const columns = [
    {
      title: "Serial",
      dataIndex: "serial",
      key: "serial",
      width: 80,
    },
    {
      title: "Cliente",
      dataIndex: "customerName",
      key: "customerName",
      width: 250,
    },
    {
      title: "Vendedor",
      dataIndex: "seller",
      key: "seller",
      width: 160,
    },
    {
      title: "Telefono",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      width: 130,
    },
    {
      title: "Distrito",
      dataIndex: "district",
      key: "district",
      filters: dataNew && dataNew.length ? [...new Map(dataNew.map(item => [item.district, item])).values()].map((order) => {
        return {
          text: order.district,
          value: order.district.toUpperCase()
        }
      }).sort((a, b) => a.text.localeCompare(b.text)) : null,
      onFilter: (value, record) => record.district.toLowerCase() === value.toLowerCase(),
      width: 210,
    },
    {
      title: "Direccion",
      dataIndex: "address",
      key: "address",
      width: 350,
    },
    {
      title: "Courier",
      dataIndex: "courier",
      key: "courier",
      width: 150,
    },
    {
      title: "Tipo de Pago",
      dataIndex: "paymenttype",
      key: "paymenttype",
      width: 150,
    },
    {
      title: "Canal",
      dataIndex: "channel",
      key: "channel",
      width: 180,
    },
    {
      title: "Canal de Venta",
      dataIndex: "salesclosingchannel",
      key: "salesclosingchannel",
      width: 150,
    },
    {
      title: "Comprobante",
      dataIndex: "fileImage",
      key: "fileImage",
      width: 200,
      render: (_, record) => {
        return !record.fileImage || !record.fileImage.length ? (
          <p>S/C</p>
        ) : (
          <Button type="link" onClick={() => selectReceipts(record)}>
            Visualizar
          </Button>
        );
      },
    },
    {
      title: "Pago",
      dataIndex: "payment",
      key: "payment",
      width: 150,
    },
    {
      title: "Monto Venta",
      dataIndex: "saleAmount",
      key: "saleAmount",
      width: 130,
      render: (_, record) => {
        return <span>${record.saleAmount.toFixed(2)}</span>;
      },
    },
    {
      title: "Monto Envio",
      dataIndex: "shippingAmount",
      key: "shippingAmount",
      width: 130,
      render: (_, record) => {
        return <span>${record.shippingAmount.toFixed(2)}</span>;
      },
    },
    {
      title: "Pago adelantado",
      dataIndex: "advanceDelivery",
      key: "advanceDelivery",
      width: 150,
      render: (_, record) => {
        return <span>${record.advanceDelivery.toFixed(2)}</span>;
      },
    },
    {
      title: "Pago pendiente",
      dataIndex: "payable",
      key: "payable",
      width: 150,
      render: (_, record) => {
        return <span>${record.payable.toFixed(2)}</span>;
      },
    },
    {
      title: "Observaciones",
      dataIndex: "comments",
      key:"comments",
      width: 300,
      render: (_,record) => record.comments ? record.comments : "SIN OBSERVACIONS",
    },
    {
      title: "Fecha Pedido",
      dataIndex: "dateStart",
      key: "dateStart",
      width: 175,
      render: (_, record) => {
        return (
          <>
            {typeof record.dateStart !== "string" ? (
              <span>{formatTimestamp(record.dateStart, 'hour')}</span>
            ) : null}
          </>
        );
      },
      sorter: (a, b) => b.dateStart.seconds - a.dateStart.seconds,
      defaultSortOrder: 'ascend',
    },
    {
      title: "Fecha Preparacion",
      dataIndex: "dateEnd",
      key: "dateEnd",
      width: 175,
      render: (_, record) => {
        return (
          <>
            {typeof record.dateEnd !== "string" ? (
              <span>{formatTimestamp(record.dateEnd, 'hour')}</span>
            ) : null}
          </>
        );
      },
      sorter: (a, b) => b.dateEnd.seconds - a.dateEnd.seconds,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 150,
      filters: [{ text: "Preparado", value: "Preparado" }, { text: "En ruta", value: "En ruta" }],
      onFilter: (value, record) => record.status === value,
      render: (_, record) => {
        return (
          <>
            {statusList[record.status] ? (
              <Tag color={statusList[record.status].color}>{record.status}</Tag>
            ) : null}
          </>
        );
      },
    },
  ];

  return (
    <>
      <Card title={
        <div className="flex justify-between items-center">
          <div>
            Lista de órdenes en ruta
          </div>
          <div>
            {dataNew.length} Ordenes
          </div>
          <Button onClick={handleCopyButtonClick}>Copiar</Button>
        </div>
      } >
        <Table
          rowSelection={rowSelection}
          dataSource={dataNew}
          columns={columns}
          scroll={{ x: 1300, y: 500 }}
        />
      </Card>
      <Gallery
        images={receipts}
        isModalOpen={openReceipt}
        setIsModalOpen={setOpenReceipt}
      />
    </>
  );
};
